module.exports = __webpack_public_path__ + "media/images/sk1000-1e2f797ca7c51caac008548591ea35d5.svg";